import { Tooltip, Text } from '@chakra-ui/react';

import React, { memo, useRef, useState, useLayoutEffect, useMemo } from 'react';
import { KText } from '@/ui-library/components/text';

export const TooltipText = memo(
  ({
    text,
    stringLength = 10,
    position = 'bottom',
    variant = undefined,
    size = undefined,
    tooltipProps,
    ...props
  }) => {
    if (!text) return null;
    if (text?.length <= stringLength)
      return (
        <Text size={size} {...props}>
          {text}
        </Text>
      );
    const displayText = text.substring(0, stringLength);
    const showElipsis = text?.length > stringLength;
    return (
      <Tooltip
        label={text}
        placement={position}
        borderRadius="6px"
        variant={variant}
        {...tooltipProps}
      >
        <Text size={size} {...props}>
          {displayText}
          {showElipsis && '...'}
        </Text>
      </Tooltip>
    );
  }
);

TooltipText.displayName = 'TooltipText';

export const TruncatedTextWithTooltip = memo(
  ({
    text = '',
    placement = 'bottom',
    toolTipVariant = undefined,
    size = undefined,
    enableTooltip: _enableTooltip = true,
    renderText = undefined,
    children = undefined,
    ...props
  }) => {
    const textRef = useRef(null);
    const [isTextTruncated, setIsTextTruncated] = useState(false);

    useLayoutEffect(() => {
      const element = textRef.current;
      if (element) {
        setIsTextTruncated(element.scrollWidth > element.clientWidth);
      } else {
        setIsTextTruncated(false);
      }
    }, [text]);

    const enableProps = useMemo(
      () =>
        toolTipVariant
          ? {}
          : {
              placement,
              background: '#161616',
              borderRadius: '3px',
              arrowSize: 8,
              p: '8px',
            },
      [toolTipVariant, placement]
    );

    return (
      <Tooltip
        label={isTextTruncated ? text : ''}
        hasArrow
        {...enableProps}
        variant={toolTipVariant}
        zIndex={99999}
      >
        {children ? (
          <div>{React.cloneElement(children, { ref: textRef })}</div>
        ) : (
          <KText
            enableTooltip={false}
            size={size}
            ref={textRef}
            isTruncated
            as={renderText && isTextTruncated ? 'span' : undefined}
            {...props}
          >
            {renderText ? renderText(text) : text}
          </KText>
        )}
      </Tooltip>
    );
  }
);

TruncatedTextWithTooltip.displayName = 'TruncatedTextWithTooltip';
